import React, { createContext, useReducer } from 'react';
import {languageReducer} from '../reducer/languageReducer'
import {GET_LANGUAGE} from '../types/Type'
import ContextDevTool from 'react-context-devtool';



export const LanguageContext = createContext()

const LanguageContextProvider = (props) => {

    const init = {
        language: {
            langList: ['Danish','English'], 
            langHeader: 'English', 
            lang: 'Language', 
            calculateHeader: 'Calculate', 
            inputWeight: 'Input your weight', 
            inputHeight: 'Input your height', 
            btn: {
                calculateBtn: 'Calculate BMI', 
                clearBmiBtn: 'Clear BMI', 
                clearAllBtn: 'Clear All',
                btnCmKg: 'Cm & Kg',
                btnFeetPound: 'Feet & Pound',
                btnFeetStone: 'Feet & Stone',
                btnInchPound: 'Inch & Stone'
            }
        }
    }

    const [stateLanguage, dispatch] = useReducer(languageReducer, init);


  const getLanguage = (lang) => {
    dispatch({
        type: GET_LANGUAGE,
        payload: languageOptions(lang)
    })
  }

  const languageOptions = (lang) => {
    switch(lang){
        case 'Danish':
            // lang = 'Denish';
            console.log(lang);
            return {
                language: { 
                langList: ['Dansk','Englisk'],
                langHeader: 'Dansk', 
                lang: 'Sprog',
                calculateHeader: 'Udregn', 
                inputWeight: 'Intast din vægt', 
                inputHeight: 'Intast din højde', 
                btn: {
                    calculateBtn: 'Udregn BMI', 
                    clearBmiBtn: 'Slet BMI', 
                    clearAllBtn: 'Reset',
                    btnCmKg: 'Cm & Kg',
                    btnFeetPound: 'Fod & Pund',
                    btnFeetStone: 'Fod & Sten',
                    btnInchPound: 'Tomme & Sten'}
                }
            }
        case 'English':
            // lang = 'English';
            console.log(lang);
            return {
                language: {
                langList: ['Danish','English'],
                langHeader: 'English', 
                lang: 'Language',
                calculateHeader: 'Calculate', 
                inputWeight: 'Input your weight', 
                inputHeight: 'Input your height', 
                btn: {
                    calculateBtn: 'Calculate BMI', 
                    clearBmiBtn: 'Clear BMI', 
                    clearAllBtn: 'Clear All',
                    btnCmKg: 'Cm & Kg',
                    btnFeetPound: 'Feet & Pound',
                    btnFeetStone: 'Feet & Stone',
                    btnInchPound: 'Inch & Stone'}
                }
            }
        default:
            // lang = 'English';
            console.log(lang);
            return {
                language: {
                langList: ['Danish','English'],
                langHeader: 'English', 
                lang: 'Language',
                calculateHeader: 'Calculate', 
                inputWeight: 'Input your weight', 
                inputHeight: 'Input your height', 
                btn: {
                    calculateBtn: 'Calculate BMI', 
                    clearBmiBtn: 'Clear BMI', 
                    clearAllBtn: 'Clear All',
                    btnCmKg: 'Cm & Kg',
                    btnFeetPound: 'Feet & Pound',
                    btnFeetStone: 'Feet & Stone',
                    btnInchPound: 'Inch & Stone'}
                }
            }
    }

}
    const language = stateLanguage.language
    const btn = stateLanguage.language.btn
    return(
        <LanguageContext.Provider value={{language, btn, getLanguage}}>
            <ContextDevTool context={LanguageContext} id="LanguageContext" displayName="LanguageContext" />
            {props.children}
        </LanguageContext.Provider>
    )
}

export default LanguageContextProvider